import { useSyncExternalStore } from 'react';
import { getLanguage, subscribeLanguage } from '@/utils/i18n/languageManager';
import type { Language } from '@/utils/i18n/types';

/** Subscribe even in memoized components; callers may also use the selected locale. */
export const useLanguage = (): Language =>
  useSyncExternalStore(subscribeLanguage, getLanguage, () => 'pt-BR');
